/**
 * UtilityQuality - Represents the quality metadata for a utility node.
 * 
 * Maps directly to fields on:
 *   CifSubsurfaceConflictAnalysis.BaseNode_HmiDataSetGeometryAspect
 * 
 * All properties are kept as strings to match the source schema and
 * allow straightforward serialization/deserialization.
 */
export class UtilityQuality {
  /** Quality level for the utility (e.g. SUE quality level) */
  QualityLevel: string;

  /** Investigation level / survey level */
  InvestigationLevel: string;

  /** Responsible authority / organization */
  Authority: string;

  /** Human-readable authority description */
  AuthorityDescription: string;

  constructor(data: {
    QualityLevel: string;
    InvestigationLevel: string;
    Authority: string;
    AuthorityDescription: string;
  }) {
    this.QualityLevel = data.QualityLevel;
    this.InvestigationLevel = data.InvestigationLevel;
    this.Authority = data.Authority;
    this.AuthorityDescription = data.AuthorityDescription;
  }

  /**
   * Creates a UtilityQuality from a plain object (e.g. ECSQL row).
   */
  static fromObject(obj: Partial<UtilityQuality>): UtilityQuality {
    return new UtilityQuality({
      QualityLevel: obj.QualityLevel ?? "",
      InvestigationLevel: obj.InvestigationLevel ?? "",
      Authority: obj.Authority ?? "",
      AuthorityDescription: obj.AuthorityDescription ?? "",
    });
  }

  /**
   * Convenience empty instance with all fields defaulted.
   */
  static empty(): UtilityQuality {
    return new UtilityQuality({
      QualityLevel: "",
      InvestigationLevel: "",
      Authority: "",
      AuthorityDescription: "",
    });
  }

  /**
   * Converts UtilityQuality to a plain object (for JSON export, etc.).
   */
  toObject(): Record<string, unknown> {
    return {
      QualityLevel: this.QualityLevel,
      InvestigationLevel: this.InvestigationLevel,
      Authority: this.Authority,
      AuthorityDescription: this.AuthorityDescription,
    };
  }
}
